
<div class="page-layout">
  <div class="modal-backdrop">
    <div class="task-modal-card">
      <header class="modal-header">
        <div class="header-left">
          <h2 class="modal-title">Meeting Details</h2>
          <span class="id-badge" *ngIf="!data.isRecurring">Scheduled Meeting</span>
          <span class="id-badge recurring-badge" *ngIf="data.isRecurring">
            <span class="material-icons" style="font-size: 14px; margin-right: 4px;">repeat</span>
            Recurring {{ getRecurrenceLabel(data.recurrencePattern) }}
          </span>
        </div>
        <div class="header-actions">
          <button class="btn-complete" *ngIf="data.joinUrl" (click)="joinMeeting(data.joinUrl)" title="Go to Meeting">
            <span class="material-icons">videocam</span> Go to Meeting
          </button>
          <button *ngIf="!isPastMeeting()" class="btn-edit" (click)="openEditMeetingDialog()" title="Edit this meeting">
            <span class="material-icons">edit</span> Edit
          </button>
          <button *ngIf="!isPastMeeting()" class="btn-cancel" [disabled]="isDeleting" (click)="openCancelConfirmDialog()" title="{{ data.isRecurring ? 'Cancel entire recurring series' : 'Cancel this meeting' }}">
            <span class="material-icons">delete_outline</span> 
            <span *ngIf="!isDeleting">{{ data.isRecurring ? 'Cancel Series' : 'Cancel Meeting' }}</span>
            <span *ngIf="isDeleting">Cancelling...</span>
          </button>

          <span class="material-icons close-icon" mat-dialog-close>close</span>
        </div>
      </header>
    
      <div class="modal-body-grid">
        <main class="main-content">
          <div class="section-block">
            <label class="section-label">Meeting Subject</label>
            <h3 class="task-headline" title="{{ data.meetingSubject | titlecase }}">{{ data.meetingSubject | titlecase }}</h3>
          </div>

          <div class="section-block">
            <label class="section-label">Meeting Agenda</label>
            <div *ngIf="data.agenda" class="agenda-text"  title="{{ data.agenda }}">{{ data.agenda }}</div>
            <div *ngIf="!data.agenda" class="agenda-text">No Agenda</div>
          </div>

          <div class="section-block">
            <label class="section-label">Notes</label>
            <div class="activity-timeline">
              <div class="timeline-item" *ngFor="let comment of meetingComments">
                <div class="user-avatar">{{ (comment.createdBy || '?').slice(0,2) }}</div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class="user-name">{{comment.createdBy}}</span>
                    <span class="time">{{ formatActivityDate(comment.createdDate) }}</span>
                    <span class="comment-actions" *ngIf="isOwnComment(comment)">
                      <button class="comment-action-btn" (click)="startEditComment(comment)" title="Edit note">
                        <span class="material-icons">edit</span>
                      </button>
                      <button class="comment-action-btn delete" (click)="confirmDeleteComment(comment)" title="Delete note">
                        <span class="material-icons">delete</span>
                      </button>
                    </span>
                  </div>
                  <div class="timeline-detail">
                    <div class="detail-row">
                      <span class="detail-label">Action:</span>
                      <span class="detail-value">{{ comment.action || 'COMMENT' }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Comments:</span>
                      <div *ngIf="editingComment !== comment" class="detail-value" [title]="comment.notesData" [innerHTML]="comment.notesData"></div>
                      <div *ngIf="editingComment === comment" class="edit-comment-box">
                        <ngx-editor-menu [editor]="editEditor" [toolbar]="toolbar"></ngx-editor-menu>
                        <ngx-editor [editor]="editEditor" [(ngModel)]="editText" [disabled]="false" style="height: 150px; border-top: 1px solid #ddd;"></ngx-editor>
                        <div class="edit-actions">
                          <button class="btn-save-edit" (click)="saveEditComment()">Save</button>
                          <button class="btn-cancel-edit" (click)="cancelEditComment()">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="add-comment-box">
            <div class="editor-wrapper">
              <div class="editor-label">Add Note</div>
              <div class="editor border-4">
                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                </ngx-editor-menu>
                <ngx-editor [editor]="editor" [(ngModel)]="newCommentText" [disabled]="false"
                  [placeholder]="'Write a comment...'" style="height: 100px; border-top: 1px solid #ddd;">
                </ngx-editor>
              </div>
            </div>
            <button class="btn-icon" (click)="postCommentByMeetingId()" *ngIf="newCommentText">
              <span class="material-icons">send</span>
            </button>
          </div>

          <!-- Meeting Assets Section -->
          <div class="section-block meeting-assets-section">

            <!-- Recurring Meeting Date Selector -->
            <div *ngIf="isRecurring" class="occurrence-date-selector">
              <label class="section-label">Select Occurrence Date</label>
              <div class="occurrence-date-row" *ngIf="!isLoadingOccurrences">
                <select class="occurrence-date-select"
                        [ngModel]="selectedOccurrenceDate"
                        (ngModelChange)="onOccurrenceDateChange($event)">
                  <option value="" disabled>Select a date...</option>
                  <option *ngFor="let occ of occurrences"
                          [value]="occ.occurrenceDate">
                    {{ occurrenceOptionLabel(occ) }}
                  </option>
                </select>
                <button *ngIf="selectedOccurrenceCacheId && !occurrenceAssetsLoaded && !isLoadingAssets"
                        class="asset-btn fetch-btn"
                        (click)="triggerOccurrenceFetch()"
                        [disabled]="isFetching">
                  <span class="material-icons">{{ isFetching ? 'sync' : 'cloud_download' }}</span>
                  {{ isFetching ? 'Fetching...' : 'Fetch Assets' }}
                </button>
              </div>
              <div class="occurrence-actions" *ngIf="selectedOccurrenceDate && !isLoadingOccurrences">
                <button type="button"
                        class="occurrence-action-btn edit-btn"
                        (click)="openOccurrenceTimeEditor()"
                        [disabled]="!canManageSelectedOccurrence()"
                        title="Edit start/end time for this single occurrence only">
                  <span class="material-icons">edit_calendar</span> Edit Time
                </button>
                <button type="button"
                        class="occurrence-action-btn delete-btn"
                        (click)="openCancelOccurrenceConfirm()"
                        [disabled]="!canManageSelectedOccurrence()"
                        title="Cancel this single occurrence only">
                  <span class="material-icons">event_busy</span> Cancel This Occurrence
                </button>
              </div>
              <div class="occurrence-actions-note"
                   *ngIf="selectedOccurrenceDate && selectedOccurrence && !canManageSelectedOccurrence()">
                <span *ngIf="selectedOccurrenceIsCancelled()">This occurrence has been cancelled.</span>
                <span *ngIf="!selectedOccurrenceIsCancelled() && selectedOccurrenceInPast()">This occurrence has already ended.</span>
              </div>
              <div *ngIf="isLoadingOccurrences" class="occurrence-loading">
                <span class="material-icons spinning">sync</span> Loading occurrences...
              </div>
            </div>

            <label class="section-label" *ngIf="!isRecurring">Recording & Transcript</label>

            <div *ngIf="assetsLoadError" class="asset-row error-row">
              <span class="material-icons asset-icon">error_outline</span>
              <span class="asset-status-text">Could not load meeting assets.</span>
            </div>

            <!-- Loading assets for selected occurrence -->
            <div *ngIf="isLoadingAssets && isRecurring && selectedOccurrenceDate" class="asset-row loading-row">
              <span class="material-icons spinning">sync</span>
              <span class="asset-status-text">Loading assets for selected date...</span>
            </div>

            <!-- No assets message for recurring -->
            <div *ngIf="isRecurring && selectedOccurrenceDate && !isLoadingAssets && !assetsLoadError && transcripts.length === 0 && recordings.length === 0 && !aiNotes" class="asset-row">
              <span class="material-icons asset-icon">info_outline</span>
              <div class="asset-info">
                <span class="asset-label">No recordings or transcripts available for this date</span>
              </div>
            </div>

            <!-- Transcript Row -->
            <div class="asset-row" *ngIf="transcripts.length > 0">
              <span class="material-icons asset-icon">description</span>
              <div class="asset-info">
                <span class="asset-label">Transcript</span>
                <span class="asset-badge available">Available</span>
              </div>
              <div class="asset-actions">
                <button class="asset-btn" (click)="downloadTranscriptContent(transcripts[0])" [disabled]="isDownloadingTranscript" title="Download Transcript">
                  <span class="material-icons">{{ isDownloadingTranscript ? 'sync' : 'download' }}</span> Download
                </button>
                <button class="asset-btn" (click)="viewTranscriptInline(transcripts[0])" title="View Transcript">
                  <span class="material-icons">visibility</span> View
                </button>
                <!-- <button class="asset-btn" (click)="viewInTeams()" title="View in Teams">
                  <span class="material-icons">open_in_new</span> Teams
                </button> -->
              </div>
            </div>

            <!-- No Transcript Row -->
            <div class="asset-row" *ngIf="transcripts.length === 0 && !isLoadingAssets && !assetsLoadError">
              <span class="material-icons asset-icon">description</span>
              <div class="asset-info">
                <span class="asset-label">Transcript</span>
                <span class="asset-badge unavailable">Not Available</span>
              </div>
              <div class="asset-actions">
                <span class="asset-hint">Requires Live Transcription during meeting</span>
              </div>
            </div>

            <!-- Recording Row -->
            <div class="asset-row" *ngIf="recordings.length > 0">
              <span class="material-icons asset-icon">videocam</span>
              <div class="asset-info">
                <span class="asset-label">Recording</span>
                <span class="asset-badge available">Available</span>
              </div>
              <div class="asset-actions">
                <button class="asset-btn" (click)="downloadRecordingFile(recordings[0])" [disabled]="isDownloadingRecording" title="Download Recording">
                  <span class="material-icons">{{ isDownloadingRecording ? 'sync' : 'download' }}</span> Download
                </button>
                <button class="asset-btn" (click)="viewRecordingInApp(recordings[0])" [disabled]="isLoadingRecording" title="View Recording">
                  <span class="material-icons">{{ isLoadingRecording ? 'sync' : 'play_circle' }}</span> Play
                </button>
                <!-- <button class="asset-btn" (click)="viewInTeams()" title="Open Teams">
                  <span class="material-icons">open_in_new</span> Teams
                </button> -->
              </div>
            </div>

            <!-- No Recording Row -->
            <div class="asset-row" *ngIf="recordings.length === 0 && !isLoadingAssets && !assetsLoadError">
              <span class="material-icons asset-icon">videocam</span>
              <div class="asset-info">
                <span class="asset-label">Recording</span>
                <span class="asset-badge unavailable">Not Available</span>
              </div>
              <div class="asset-actions">
                <span class="asset-hint">Recording is generated after the meeting ends</span>
              </div>
            </div>

            <!-- AI Notes Row -->
            <div class="asset-row" *ngIf="aiNotes">
              <span class="material-icons asset-icon">auto_awesome</span>
              <div class="asset-info">
                <span class="asset-label">AI Summary</span>
                <span class="asset-badge available">Available</span>
              </div>
              <div class="asset-actions">
                <button class="asset-btn" (click)="downloadAiNotes()" [disabled]="isDownloadingAiNotes" title="Download AI Notes">
                  <span class="material-icons">{{ isDownloadingAiNotes ? 'sync' : 'download' }}</span> Download
                </button>
                <button class="asset-btn" (click)="viewAiNotesInline()" title="View AI Notes">
                  <span class="material-icons">visibility</span> View
                </button>
              </div>
            </div>

            <!-- No AI Notes Row -->
            <div class="asset-row" *ngIf="!aiNotes && !isLoadingAssets && !assetsLoadError">
              <span class="material-icons asset-icon">auto_awesome</span>
              <div class="asset-info">
                <span class="asset-label">AI Notes</span>
                <span class="asset-badge unavailable">Not Available</span>
              </div>
              <div class="asset-actions">
                <span class="asset-hint">Insights may take up to 4 hours after the meeting ends</span>
              </div>
            </div>
          </div>

          <!-- Loading state -->
          <div class="section-block loading-assets" *ngIf="isLoadingAssets">
            <label class="section-label">Recording & Transcript</label>
            <div class="asset-row">
              <span class="material-icons asset-icon">hourglass_empty</span>
              <span class="asset-status-text">Loading meeting assets...</span>
            </div>
          </div>
        </main>

        <aside class="sidebar-meta">
          <div class="meta-card">
            <label>Hospital Name</label>
            <div class="status-badge hospital">
              <span class="material-icons">local_hospital</span>
              {{ data.hospitalName }}
            </div>
          </div>

          <div class="meta-group">
            <div class="meta-item">
              <span class="material-icons item-icon">calendar_today</span>
              <div class="meta-data">
                <label>Scheduled Date</label>
                <span>{{ data.scheduledDate | date:'fullDate' }}</span>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">schedule</span>
              <div class="meta-data">
                <label>Time & Duration</label>
                <span>{{ data.startTime }} - {{ data.endTime }} ({{ data.duration }})</span>
              </div>
            </div>

            <div class="meta-item" *ngIf="data.isRecurring">
              <span class="material-icons item-icon">repeat</span>
              <div class="meta-data">
                <label>Recurrence</label>
                <span>Repeats {{ getRecurrenceLabel(data.recurrencePattern) }}
                  <ng-container *ngIf="data.recurrenceEndDate"> until {{ data.recurrenceEndDate | date:'mediumDate' }}</ng-container>
                </span>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">person_outline</span>
              <div class="meta-data">
                <label>Organized By</label>
                <div class="user-chip">
                  <div class="tiny-avatar">{{ (data.createdUserName || 'LO').slice(0,2) }}</div>
                  <span>{{ data.createdUserName || "LTK Organizer" }}</span>
                </div>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">flag</span>
              <div class="meta-data">
                <label>Goal Name</label>
                <span class="detail-value">{{ data.goalName }}</span>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">location_on</span>
              <div class="meta-data">
                <label>Meeting Type</label>
                <span class="detail-value">{{ data.meetingType }}</span>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">event_note</span>
              <div class="meta-data">
                <label>Quarter</label>
                <span class="detail-value">{{ data.quarter }}</span>
              </div>
            </div>

            <!-- Attendees List -->
            <div class="meta-item">
              <span class="material-icons item-icon">group</span>
              <div class="meta-data">
                <label>Attendees List</label>
                <div class="user-chip" *ngFor="let name of data.attendeesNames">
                  <div class="tiny-avatar">{{ (name || '?').slice(0,2) }}</div>
                  <span>{{ name }}</span>
                </div>
              </div>
            </div>

            <!-- Meeting Link -->
            <div class="meta-item">
              <span class="material-icons item-icon">link</span>
              <div class="meta-data">
                <label>Meeting Link</label>
                <div class="description-text">
                  <a [href]="data.joinUrl" target="_blank" class="link-styled">
                    {{ data.joinUrl }}
                  </a>
                </div>
              </div>
            </div>

            <!-- Asset Status Badges -->
            <div class="meta-item asset-status-item" *ngIf="transcriptStatus">
              <span class="material-icons item-icon">check_circle</span>
              <div class="meta-data">
                <label>Transcript Status</label>
                <span class="status-indicator" [class.available]="transcriptStatus?.hasTranscripts || transcriptStatus?.transcriptAvailable" [class.unavailable]="!transcriptStatus?.hasTranscripts && !transcriptStatus?.transcriptAvailable">
                  {{ (transcriptStatus?.hasTranscripts || transcriptStatus?.transcriptAvailable) ? 'Available' : 'Not Available' }}
                </span>
              </div>
            </div>

            <div class="meta-item asset-status-item" *ngIf="transcriptStatus">
              <span class="material-icons item-icon">videocam</span>
              <div class="meta-data">
                <label>Recording Status</label>
                <span class="status-indicator" [class.available]="transcriptStatus?.hasRecordings || transcriptStatus?.recordingAvailable" [class.unavailable]="!transcriptStatus?.hasRecordings && !transcriptStatus?.recordingAvailable">
                  {{ (transcriptStatus?.hasRecordings || transcriptStatus?.recordingAvailable) ? 'Available' : 'Not Available' }}
                </span>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</div>

  <!-- Delete Comment Confirmation Dialog -->
  <div *ngIf="deleteConfirmComment" class="confirmation-backdrop">
    <div class="confirm-dialog">
      <h3>Delete Note</h3>
      <p>Are you sure you want to delete this note? This action cannot be undone.</p>
      <div class="dialog-actions">
        <button class="btn-cancel-dialog" (click)="cancelDeleteComment()">Cancel</button>
        <button class="btn-confirm-dialog btn-delete-dialog" (click)="deleteComment()">Delete</button>
      </div>
    </div>
  </div>

  <!-- Inline Transcript Viewer Overlay -->
  <div class="viewer-overlay" *ngIf="showTranscriptViewer" (click)="closeTranscriptViewer()">
    <div class="viewer-card" (click)="$event.stopPropagation()">
      <div class="viewer-header">
        <h3>Transcript</h3>
        <button class="viewer-close-btn" (click)="closeTranscriptViewer()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="viewer-body">
        <div *ngIf="parsedTranscriptBlocks.length > 0; else rawTranscript" class="chat-conversation">
          <div class="chat-message" *ngFor="let block of parsedTranscriptBlocks; let i = index">
            <div class="chat-header">
              <span class="chat-avatar">{{ (block.speaker || '?').slice(0,2) }}</span>
              <span class="chat-name">{{ block.speaker || 'Unknown' }}</span>
              <span class="chat-time">{{ block.start }}</span>
            </div>
            <div class="chat-bubble">{{ block.text }}</div>
          </div>
        </div>
        <ng-template #rawTranscript>
          <pre class="transcript-content">{{ selectedTranscript?.plainText || selectedTranscript?.content || 'No content available.' }}</pre>
        </ng-template>
      </div>
      <div class="viewer-footer">
        <button class="asset-btn" (click)="downloadTranscriptContent(selectedTranscript)">
          <span class="material-icons">download</span> Download
        </button>
      </div>
    </div>
  </div>

  <!-- Recording Player Overlay -->
  <div class="viewer-overlay" *ngIf="showRecordingPlayer" (click)="closeRecordingPlayer()">
    <div class="viewer-card recording-card" (click)="$event.stopPropagation()">
      <div class="viewer-header">
        <h3>Recording</h3>
        <button class="viewer-close-btn" (click)="closeRecordingPlayer()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="viewer-body recording-body">
        <div class="recording-loading" *ngIf="isLoadingRecording">
          <span class="material-icons">sync</span>
          <span>Loading recording...</span>
        </div>
        <video controls autoplay class="recording-video" *ngIf="recordingPlayUrl && !isLoadingRecording">
          <source [src]="recordingPlayUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>

  <!-- AI Notes Viewer Overlay -->
  <div class="viewer-overlay" *ngIf="showAiNotesViewer" (click)="closeAiNotesViewer()">
    <div class="viewer-card" (click)="$event.stopPropagation()">
      <div class="viewer-header">
        <h3>AI Summary</h3>
        <button class="viewer-close-btn" (click)="closeAiNotesViewer()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="viewer-body ai-notes-body">
        <div *ngIf="aiNotes?.summary" class="ai-section">
          <markdown [data]="aiNotes.summary"></markdown>
        </div>
        <div *ngIf="aiNotes?.actionItems" class="ai-section">
          <h4>Action Items</h4>
          <markdown [data]="aiNotes.actionItems"></markdown>
        </div>
        <div *ngIf="!aiNotes?.summary && !aiNotes?.actionItems" class="ai-section">
          <p class="no-content">No AI notes content available.</p>
        </div>
      </div>
      <div class="viewer-footer">
        <button class="asset-btn" (click)="downloadAiNotes()">
          <span class="material-icons">download</span> Download
        </button>
      </div>
    </div>
  </div>

  <!-- Occurrence Time Editor Dialog -->
  <p-dialog [(visible)]="showOccurrenceTimeEditor"
            [modal]="true"
            header="Edit Occurrence Time"
            [style]="{width: '400px'}"
            [draggable]="false"
            [resizable]="false">
    <p class="m-0">
      <strong>{{ formatDateOnly(selectedOccurrenceDate) }}</strong>
      <br />
      Only this single occurrence will be changed. The rest of the series keeps its schedule.
    </p>
    <p class="m-0 occ-time-zone-note" *ngIf="selectedOccurrence?.timeZone">
      Times are in {{ occurrenceTimeZoneName(selectedOccurrence?.timeZone) }}.
    </p>
    <div class="occ-time-fields">
      <div class="occ-time-field">
        <label for="occStartTime">Start Time</label>
        <input id="occStartTime" type="time" [(ngModel)]="occurrenceEditStart" />
      </div>
      <div class="occ-time-field">
        <label for="occEndTime">End Time</label>
        <input id="occEndTime" type="time" [(ngModel)]="occurrenceEditEnd" />
      </div>
    </div>
    <p class="m-0 occ-time-error" *ngIf="!occurrenceEditStart || !occurrenceEditEnd">
      Start and end time are required.
    </p>
    <ng-template pTemplate="footer">
      <button type="button"
              pButton
              label="Cancel"
              icon="pi pi-times"
              (click)="showOccurrenceTimeEditor = false"
              class="p-button-text p-button-secondary"></button>
      <button type="button"
              pButton
              label="Save"
              icon="pi pi-check"
              [loading]="savingOccurrenceTime"
              [disabled]="savingOccurrenceTime"
              (click)="saveOccurrenceTime()"></button>
    </ng-template>
  </p-dialog>

  <!-- Cancel Single Occurrence Confirm Dialog -->
  <p-dialog [(visible)]="showCancelOccurrenceConfirm"
            [modal]="true"
            header="Cancel This Occurrence"
            [style]="{width: '400px'}"
            [draggable]="false"
            [resizable]="false">
    <p class="m-0">
      <strong>{{ formatDateOnly(selectedOccurrenceDate) }}</strong>
      <br />
      Are you sure you want to cancel this single occurrence?
      <br />
      The rest of the recurring series will remain scheduled.
    </p>
    <ng-template pTemplate="footer">
      <button type="button"
              pButton
              label="No, Keep It"
              icon="pi pi-times"
              (click)="showCancelOccurrenceConfirm = false"
              class="p-button-text p-button-secondary"></button>
      <button type="button"
              pButton
              label="Yes, Cancel This Occurrence"
              icon="pi pi-check"
              [loading]="cancellingOccurrence"
              [disabled]="cancellingOccurrence"
              (click)="cancelOccurrenceAction()"
              class="p-button-danger"></button>
    </ng-template>
  </p-dialog>

  <!-- PrimeNG Confirmation Dialog -->
  <p-dialog [(visible)]="showCancelConfirmDialog" 
            [modal]="true" 
            [header]="data.isRecurring ? 'Cancel Recurring Series' : 'Cancel Meeting'" 
            [style]="{width: '400px'}"
            [draggable]="false"
            [resizable]="false">
    <p class="m-0">
      <strong *ngIf="data.isRecurring">Are you sure you want to cancel this entire recurring meeting series?</strong>
      <strong *ngIf="!data.isRecurring">Are you sure you want to cancel this meeting?</strong>
      <br />
      This action cannot be undone.
      <span *ngIf="data.isRecurring"><br />All future occurrences of this meeting will be cancelled in Outlook.</span>
    </p>
    <ng-template pTemplate="footer">
      <button type="button" 
              pButton 
              label="No, Keep It" 
              icon="pi pi-times" 
              (click)="rejectCancelMeeting()" 
              class="p-button-text p-button-secondary"></button>
      <button type="button" 
              pButton 
              [label]="data.isRecurring ? 'Yes, Cancel Series' : 'Yes, Cancel Meeting'" 
              icon="pi pi-check" 
              [loading]="isDeleting"
              [disabled]="isDeleting"
              (click)="confirmCancelMeeting()" 
              class="p-button-danger"></button>
    </ng-template>
  </p-dialog>